import { motion } from 'motion/react';
import { services } from '@/mocks/homeData';

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, delay: i * 0.1, ease: 'easeOut' },
  }),
};

export default function ServicesSection() {
  return (
    <section id="services" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          className="text-center mb-12 md:mb-16"
        >
          <span className="inline-block bg-accent-100 text-accent-900 px-4 py-1.5 rounded-full text-xs md:text-sm font-semibold mb-4">
            What We Offer
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
            Our Services
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            From mobiles and home appliances to DTH services and money transfers — everything your household needs under one roof.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {services.map((service, index) => (
            <motion.div
              key={service.id}
              custom={index}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: '-60px' }}
              variants={cardVariants}
              whileHover={{ y: -8, transition: { duration: 0.25 } }}
              className="group bg-background-100 border border-background-200/70 hover:border-primary-300 rounded-xl overflow-hidden transition-all duration-300 cursor-default"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-out"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 via-foreground-950/10 to-transparent"></div>
                <div className="absolute top-3 left-3 w-10 h-10 md:w-11 md:h-11 flex items-center justify-center bg-background-50/95 rounded-xl">
                  <i className={`${service.icon} text-lg text-primary-600`}></i>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-2">
                  {service.title}
                </h3>
                <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                  {service.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}